import { render, staticRenderFns } from "./VtRichTextEditor.vue?vue&type=template&id=9b4aadac&"
import script from "./VtRichTextEditor.vue?vue&type=script&lang=js&"
export * from "./VtRichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./VtRichTextEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports